import { supabase } from '@/integrations/supabase/client';

/**
 * Clear the cached cover for a specific book
 */
export async function clearCachedCover(bookId: string): Promise<{ success: boolean; error?: string }> {
  try {
    const { data, error } = await supabase.functions.invoke('clear-cached-cover', {
      body: { book_id: bookId }
    });

    if (error) {
      console.error('Error clearing cached cover:', error);
      return { success: false, error: error.message };
    }

    return { success: true };
  } catch (error) {
    console.error('Unexpected error clearing cached cover:', error);
    return { success: false, error: String(error) };
  }
}

/**
 * Clear all cached covers (admin only)
 */
export async function clearAllCachedCovers(): Promise<{ success: boolean; count?: number; error?: string }> {
  try {
    const { data, error } = await supabase.functions.invoke('clear-cached-cover', {
      body: { clear_all: true }
    });

    if (error) {
      console.error('Error clearing all cached covers:', error);
      return { success: false, error: error.message };
    }

    return { success: true, count: data?.count };
  } catch (error) {
    console.error('Unexpected error clearing all cached covers:', error);
    return { success: false, error: String(error) };
  }
}
